var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.39 101.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.65,47.05l-10.19-3.8c-.52-.26-1.03-.79-1.11-1.04l-4.13-17.73c-.46-1.84-2.19-2.67-3.69-2.67s-3.23.83-3.69,2.67l-4.27,17.7c-.12.35-.5.83-.92,1.05l-10.23,3.82c-1.52.56-2.5,1.97-2.5,3.6s.98,3.04,2.5,3.6l10.19,3.8c.48.24.85.74.96,1.04l4.28,17.73c.47,1.77,2.2,2.55,3.75,2.55.04,0,.08,0,.11,0,1.82-.05,3.2-1.05,3.52-2.56l4.11-17.68c.1-.3.6-.82,1.08-1.07l10.23-3.82c1.52-.56,2.5-1.97,2.5-3.6s-.98-3.04-2.5-3.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIconPurple);
export default __webpack_public_path__ + "static/media/starIconPurple.e0521bdbbded68e48c1f91eaa8c59f22.svg";
export { ForwardRef as ReactComponent };